<template>
  <div id="primary-insurance">
    <div class="primary-insurance-view">
      <div class="step-inner-navbar"></div>
      <div class="step-inner-content">
        <div class="vue-form">
          <el-form v-model="primaryInsuranceForm">
            <el-row :gutter="15">
              <el-col :xl="3" :lg="4" :md="6" :sm="8" :xs="12">
                <div class="case-creation__input">
                  <el-form-item>
                    <label for="text">
                      Relationship
                      <span class="star">*</span>
                    </label>
                    <el-select
                      v-model="primaryInsuranceForm.relationship"
                      @change="fillPrimaryDetails()"
                      @clear="clearNameSerach"
                      placeholder="Select Relationship"
                      filterable
                      clearable
                      default-first-option
                      :reserve-keyword="false"
                    >
                      <el-option
                        v-for="(type, index) in relationships"
                        :key="index"
                        :value="type"
                        :label="type"
                      ></el-option>
                    </el-select>
                    <p class="err">
                      <FormError
                        errorName="billing_info.insurance.primary_insurance.relationship"
                      ></FormError>
                    </p>
                  </el-form-item>
                </div>
              </el-col>
              <el-col :xl="3" :lg="4" :md="6" :sm="8" :xs="12">
                <div class="case-creation__input">
                  <el-form-item>
                    <label for="text">
                      Plan Type
                    </label>
                    <el-select
                      placeholder="Select Plan Type"
                      v-model="primaryInsuranceForm.plan_type"
                      default-first-option
                      :reserve-keyword="false"
                      filterable
                    >
                      <el-option
                        v-for="(type, index) of planTypes"
                        :key="index"
                        :value="type"
                        :label="type"
                      ></el-option>
                    </el-select>
                    <p class="err">
                      <FormError
                        errorName="billing_info.insurance.primary_insurance.plan_type"
                      ></FormError>
                    </p>
                  </el-form-item>
                </div>
              </el-col>
              <el-col :xl="3" :lg="4" :md="6" :sm="8" :xs="12">
                <div class="case-creation__input">
                  <el-form-item>
                    <label for="text">
                      First Name
                      <span class="star">*</span>
                    </label>
                    <el-input
                      v-model="primaryInsuranceForm.first_name"
                      placeholder="Enter First Name"
                    ></el-input>
                    <p class="err">
                      <FormError
                        errorName="billing_info.insurance.primary_insurance.first_name"
                      ></FormError>
                    </p>
                  </el-form-item>
                </div>
              </el-col>
              <el-col :xl="3" :lg="4" :md="6" :sm="8" :xs="12">
                <div class="case-creation__input">
                  <el-form-item>
                    <label for="text">Middle Name</label>
                    <el-input
                      v-model="primaryInsuranceForm.middle_name"
                      placeholder="Enter Middle Name"
                    ></el-input>
                    <p class="err">
                      <FormError
                        errorName="billing_info.insurance.primary_insurance.middle_name"
                      ></FormError>
                    </p>
                  </el-form-item>
                </div>
              </el-col>
              <el-col :xl="3" :lg="4" :md="6" :sm="8" :xs="12">
                <div class="case-creation__input">
                  <el-form-item>
                    <label for="text">
                      Last Name
                      <span class="star">*</span>
                    </label>
                    <el-input
                      v-model="primaryInsuranceForm.last_name"
                      placeholder="Enter Last Name"
                    ></el-input>
                    <p class="err">
                      <FormError
                        errorName="billing_info.insurance.primary_insurance.last_name"
                      ></FormError>
                    </p>
                  </el-form-item>
                </div>
              </el-col>
              <el-col :xl="2" :lg="4" :md="6" :sm="8" :xs="12">
                <div class="case-creation__input gender-group">
                  <el-form-item>
                    <label for="text"> Gender <span class="star">*</span></label>
                    <el-select
                      v-model="primaryInsuranceForm.gender"
                      placeholder="Select Gender"
                      default-first-option
                      :reserve-keyword="false"
                      filterable
                      clearable
                    >
                      <el-option
                        v-for="(gender, index) in genderOptions"
                        :key="index"
                        :label="gender"
                        :value="gender"
                      ></el-option>
                    </el-select>
                    <p class="err">
                      <FormError
                        errorName="billing_info.insurance.primary_insurance.gender"
                      ></FormError>
                    </p>
                  </el-form-item>
                </div>
              </el-col>
              <el-col :xl="3" :lg="4" :md="6" :sm="8" :xs="12">
                <div class="date-of-birth case-creation__input">
                  <el-form-item>
                    <dobVersion
                      v-if="showPatientDob"
                      :dobData="primaryInsuranceForm"
                      :validataionErrors="getErrors"
                      :errorKey="'billing_info.insurance.primary_insurance.date_of_birth'"
                      :displayRequired="true"
                    ></dobVersion>
                  </el-form-item>
                </div>
              </el-col>

              <el-col :xl="4" :lg="4" :md="6" :sm="8" :xs="12">
                <div class="case-creation__input">
                  <el-form-item>
                    <payor
                      v-if="show"
                      :payorData="primaryInsuranceForm"
                      :validataionErrors="getErrors"
                      :clearPayor="clearPayorData"
                      @payorSelect="fillInsurance"
                      insuranceType="primary_insurance"
                      :billTo="caseBillTo"
                    ></payor>
                    <p class="err">
                      <FormError
                        errorName="billing_info.insurance.primary_insurance.payor"
                      ></FormError>
                    </p>
                  </el-form-item>
                </div>
              </el-col>
              <el-col :xl="3" :lg="4" :md="6" :sm="8" :xs="12">
                <div class="case-creation__input">
                  <el-form-item>
                    <label for="text"> Insurance Carrier Code </label>
                    <el-input
                      v-if="showCarrier"
                      v-model="primaryInsuranceForm.insurance_carrier_code"
                      placeholder="Enter Insurance Carrier Code"
                    ></el-input>
                  </el-form-item>
                </div>
              </el-col>
              <el-col :xl="3" :lg="4" :md="6" :sm="8" :xs="12">
                <div class="case-creation__input">
                  <el-form-item>
                    <label for="text">
                      Policy No
                      <span class="star">*</span>
                    </label>
                    <el-input
                      v-model="primaryInsuranceForm.policy_id"
                      placeholder="Enter Policy No"
                    ></el-input>
                    <p class="err">
                      <FormError
                        errorName="billing_info.insurance.primary_insurance.policy_id"
                      ></FormError>
                    </p>
                  </el-form-item>
                </div>
              </el-col>

              <el-col :xl="3" :lg="4" :md="6" :sm="8" :xs="12">
                <div class="case-creation__input">
                  <el-form-item>
                    <label for="text">Group #</label>
                    <el-input
                      v-model="primaryInsuranceForm.group"
                      placeholder="Enter Group #"
                    ></el-input>
                    <p class="err">
                      <FormError
                        errorName="billing_info.insurance.primary_insurance.group"
                      ></FormError>
                    </p>
                  </el-form-item>
                </div>
              </el-col>

              <el-col :xl="3" :lg="4" :md="6" :sm="8" :xs="12">
                <div class="case-creation__input">
                  <el-form-item>
                    <label for="text"> Address Line 1 <span class="star">*</span></label>
                    <el-input
                      v-model="primaryInsuranceForm.address_line_1"
                      placeholder="Enter Address Line 1"
                    ></el-input>
                    <p class="err">
                      <FormError
                        errorName="billing_info.insurance.primary_insurance.address_line_1"
                      ></FormError>
                    </p>
                  </el-form-item>
                </div>
              </el-col>
              <el-col :xl="3" :lg="4" :md="6" :sm="8" :xs="12">
                <div class="case-creation__input">
                  <el-form-item>
                    <label for="text">Address Line 2</label>
                    <el-input
                      v-model="primaryInsuranceForm.address_line_2"
                      placeholder="Enter Address Line 2"
                    ></el-input>
                    <p class="err">
                      <FormError
                        errorName="billing_info.insurance.primary_insurance.address_line_2"
                      ></FormError>
                    </p>
                  </el-form-item>
                </div>
              </el-col>
              <el-col :xl="2" :lg="4" :md="6" :sm="8" :xs="12">
                <div class="case-creation__input">
                  <el-form-item>
                    <label for="text"> Zip <span class="star">*</span></label>
                    <el-input
                      v-model="primaryInsuranceForm.zip"
                      placeholder="Enter Zip"
                      maxlength="5"
                      @input="getStateCity"
                    ></el-input>
                    <p class="err">
                      <FormError
                        errorName="billing_info.insurance.primary_insurance.zip"
                      ></FormError>
                    </p>
                  </el-form-item>
                </div>
              </el-col>
              <el-col :xl="3" :lg="4" :md="6" :sm="8" :xs="12">
                <div class="case-creation__input">
                  <el-form-item>
                    <state
                      :stateData="primaryInsuranceForm"
                      :displayRequired="true"
                    ></state>
                    <p class="err">
                      <FormError
                        errorName="billing_info.insurance.primary_insurance.state"
                      ></FormError>
                    </p>
                  </el-form-item>
                </div>
              </el-col>
              <el-col :xl="4" :lg="4" :md="6" :sm="8" :xs="12">
                <div class="case-creation__input">
                  <el-form-item>
                    <city
                      :cityData="primaryInsuranceForm"
                      v-if="show"
                      :displayRequired="true"
                    ></city>

                    <p class="err">
                      <FormError
                        errorName="billing_info.insurance.primary_insurance.city"
                      ></FormError>
                    </p>
                  </el-form-item>
                </div>
              </el-col>
            </el-row>
          </el-form>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { defineAsyncComponent } from "vue";
import caseConstants from "@/config/constants/caseConstants";
const FormError = defineAsyncComponent(() =>
  import("@/components/misc/FormError")
);
const payor = defineAsyncComponent(() => import("@/components/misc/Payor"));
const dobVersion = defineAsyncComponent(() =>
  import("@/components/misc/DobNewFormat")
);
const state = defineAsyncComponent(() =>
  import("@/components/misc/BillingState")
);
const city = defineAsyncComponent(() =>
  import("@/components/misc/BillingCity")
);
import AppHelper from "@/mixins/AppHelper";
import InsuranceHelper from "@/mixins/InsuranceHelper";

import { mapGetters } from "vuex";
import { ElMessageBox } from "element-plus";

export default {
  props: [
    "primaryInsurance",
    "refreshDob",
    "parentRefs",
    "physicianPecos",
    "state",
    "orderingPhysician",
    "billTo",
    "foundCoveragesEdit",
  ],
  data() {
    return {
      primaryInsuranceForm: JSON.parse(JSON.stringify(caseConstants.insurance)),
      relationships: caseConstants.BILLING_RELATIONSHIPS,
      planTypes: ["INDIVIDUAL", "FAMILY"],
      genderOptions: ["MALE", "FEMALE"],
      payorData: {},
      show: false,
      showPatientDob: false,
      caseId: "",
      clearPayorData: false,
      showInsuranceFields: false,
      summaryData: {},
      patientData: {},
      facilityState: "",
      stateCarrierMapping: caseConstants.stateCarrierMapping,
      stateMedicaidCarrierMapping: caseConstants.stateMedicaidCarrierMapping,
      stateAetnaMapping: caseConstants.stateAetnaMapping,
      caseBillTo: "",
      showCarrier: false,
      foundCoverages: [],
    };
  },
  components: {
    FormError,
    payor,
    dobVersion,
    state,
    city,
  },
  mixins: [AppHelper, InsuranceHelper],
  computed: {
    ...mapGetters("help", ["getAllStates"]),
    ...mapGetters("cases", [
      "getCaseInformation",
      "getStateAndCity",
      "getInsuranceEligibilityDetails",
      "getPayorDetails",
      "getInsuranceDetails",
    ]),
    ...mapGetters("errors", ["getErrors"]),
  },
  async mounted() {
    // this.fetchStates();
    this.show = true;
    this.showPatientDob = true;
    this.showCarrier = true;
    if (this.primaryInsurance) {
      this.primaryInsuranceForm = { ...this.primaryInsurance };
    }
    if (this.$route.params.case_id) {
      this.caseId = this.$route.params.case_id;
      
      if (
        this.$route.name === "Case-Information-Update" &&
        this.$route.query.insuranceUpdate === "Replaced"
      ) {
        await this.fetchInsuranceDetails();
      } else {
        await this.$store.commit("cases/setInsuranceEligibilityDetails", null);
        await this.$store.commit("cases/setInsuranceDetails", null);
      }
      if (this.$route.name == "Concurrent-Case-Information-Update") {
        await this.$store.commit("cases/setInsuranceEligibilityDetails", null);
        await this.$store.commit("cases/setInsuranceDetails", null);
      }
      await this.checkCaseInfo();
      this.patientData = this.getCaseInformation
        ? this.getCaseInformation.patient_info
        : {};
    }
    this.facilityState = this.state;
  },

  methods: {
    async fetchInsuranceDetails() {
      await this.$store.dispatch(
        "cases/fetchCaseInsuranceDetails",
        this.caseId
      );
    },

    async getStateCity() {
      try {
        let params = {
          zip: this.primaryInsuranceForm.zip,
        };
        await this.$store.dispatch("cases/getStateCity", params);
        if (this.getStateAndCity) {
          this.primaryInsuranceForm.state = this.getStateAndCity.state;
          this.primaryInsuranceForm.city = this.getStateAndCity.city;
        } else {
          if (!this.getStateAndCity && params.zip.length == 5) {
            this.$message({
              message: "No State & City Found",
              type: "warning",
            });
          }
        }
      } catch (error) {
        console.log(error);
      }
    },
    async fetchStates() {
      await this.$store.dispatch("help/fetchAllStates");
    },
    getPrimaryInsuranceFormData() {
      return this.getFormattedValues(this.primaryInsuranceForm);
    },

    checkCaseInfo() {
      if (
        this.getInsuranceDetails &&
        this.getInsuranceDetails.data &&
        this.getInsuranceDetails.data.insurance_verified_details &&
        this.getInsuranceDetails.data.insurance_verified_details
          .insurance_eligibility_verified_details.foundCoverages &&
        this.getInsuranceDetails.data.insurance_verified_details
          .insurance_eligibility_verified_details.foundCoverages.length > 1
      ) {
        this.foundCoverages =
          this.getInsuranceDetails.data.insurance_verified_details.insurance_eligibility_verified_details.foundCoverages;
      }
      if (
        this.getCaseInformation &&
        this.getCaseInformation.insurance_eligibility_verified &&
        this.getCaseInformation.insurance_eligibility_verified_details &&
        this.getCaseInformation.insurance_eligibility_verified_details
          .foundCoverages &&
        this.getCaseInformation.insurance_eligibility_verified_details
          .foundCoverages[0]
      ) {
        this.showInsuranceFields = true;
        this.summaryData =
          this.getCaseInformation.insurance_eligibility_verified_details.foundCoverages[0].summary;
      }
    },
    fillInsurance(data) {
      if (data && data.name == "BCBS") {
        this.primaryInsuranceForm.payor = data.name;
        this.primaryInsuranceForm.insurance_carrier_code =
          this.stateCarrierMapping[this.facilityState] || "";
      } else if (data && data.name == "Medicaid") {
        this.primaryInsuranceForm.payor = data.name;
        this.primaryInsuranceForm.insurance_carrier_code =
          this.stateMedicaidCarrierMapping[this.facilityState] || "";
      } else if (data && data.name == "Aetna") {
        this.primaryInsuranceForm.payor = data.name;
        this.primaryInsuranceForm.insurance_carrier_code =
          this.stateAetnaMapping[this.facilityState] || "";
      } else if (data) {
        this.primaryInsuranceForm.payor = data.name;
        if (data.name && data.name == "CMS-MEDICARE" && this.checkColonyLab) {
          this.primaryInsuranceForm.insurance_carrier_code = "SMTX0";
        } else if (data.name && data.name == "CMS-MEDICARE" && this.isDLWLab) {
          this.primaryInsuranceForm.insurance_carrier_code = "SMAL0";
        } else if (data.payor_electronic_id) {
          this.showCarrier = false;
          this.primaryInsuranceForm.insurance_carrier_code =
            data.payor_electronic_id;
          this.showCarrier = true;
        } else {
          this.primaryInsuranceForm.insurance_carrier_code = "";
        }

        const regex = /medicare/i;

        if (
          regex.test(this.primaryInsuranceForm.payor) &&
          this.orderingPhysician &&
          (this.physicianPecos === false || this.physicianPecos == null)
        ) {
          ElMessageBox.confirm(
            "Physician PECOS status is not verified. Do you want to proceed?",
            "Warning",
            {
              confirmButtonText: "OK",
              cancelButtonText: "Cancel",
              type: "warning",
            }
          )
            .then(() => {})
            .catch(() => {});
        }
      }
    },
    clearNameSerach() {
      this.primaryInsuranceForm = {
        relationship: "",
        plan_type: "",
        payor: "",
        insurance_code: "",
        gender: "",
        date_of_birth: "",
        policy_plan: "",
        group_or_plan: "",
        group: "",
        patient_policy: "",
        address_line_1: "",
        address_line_2: "",
        city: "",
        state: "",
        zip: "",
        first_name: "",
        middle_name: "",
        last_name: "",
      };
      this.clearPayorData = true;
      setTimeout(() => {
        this.show = true;
      }, 100);
    },

    fillPrimaryDetails() {
      this.clearPayorData = false;
      if (this.primaryInsuranceForm.relationship === "Self") {
        this.showPatientDob = false;
        let patientInformation =
          this.parentRefs && this.parentRefs.patientInformationForm
            ? this.parentRefs.patientInformationForm.formatPatientInfo()
            : this.patientData;
        this.primaryInsuranceForm.first_name = patientInformation.first_name;
        this.primaryInsuranceForm.middle_name = patientInformation.middle_name;
        this.primaryInsuranceForm.last_name = patientInformation.last_name;
        this.primaryInsuranceForm.gender = patientInformation.gender;

        this.primaryInsuranceForm.date_of_birth =
          patientInformation.date_of_birth;

        this.primaryInsuranceForm.city = patientInformation.city;
        this.primaryInsuranceForm.state = patientInformation.state;
        this.primaryInsuranceForm.zip = patientInformation.zip;
        this.primaryInsuranceForm.address_line_1 =
          patientInformation.address_line_1;
        this.primaryInsuranceForm.address_line_2 =
          patientInformation.address_line_2;

        setTimeout(() => {
          this.show = true;
          this.showPatientDob = true;
          this.showCarrier = true;
        }, 100);
      }
    },
    async setReplacedInsuranceData(data) {
      await this.$store.dispatch(
        "cases/fetchPayorElectronicData",
        data.payerCode
      );
      if (this.getPayorDetails && this.getPayorDetails.data) {
        this.show = false;
        setTimeout(() => {
          this.primaryInsuranceForm.payor = data.payerName || "";
          this.primaryInsuranceForm.policy_id = data.memberId || "";
          this.primaryInsuranceForm.insurance_carrier_code =
            this.getPayorDetails.data.payor_electronic_id || "";
          this.show = true;
        }, 500);
      }
    },
  },
  watch: {
    refreshDob: {
      immediate: true,
      deep: true,
      handler: function () {
        this.showPatientDob = this.refreshDob;
      },
    },
    state: {
      immediate: true,
      deep: true,
      handler: function () {
        this.facilityState = this.state;
      },
    },
    foundCoverages: {
      handler(newVal) {
        if (Array.isArray(newVal) && newVal.length > 1) {
          const replacedCoverage = newVal.find(
            (coverage) => coverage.additionalDetail === "Replaced"
          );

          const noDetailCoverage = newVal.find(
            (coverage) => !coverage.additionalDetail
          );
          // this.show = false;
          if (replacedCoverage && noDetailCoverage) {
            this.setReplacedInsuranceData(noDetailCoverage);
          }
        }
      },
      deep: true,
      immediate: true,
    },
    foundCoveragesEdit: {
      handler(newVal) {
        if (Array.isArray(newVal) && newVal.length > 1) {
          const replacedCoverage = newVal.find(
            (coverage) => coverage.additionalDetail === "Replaced"
          );

          const noDetailCoverage = newVal.find(
            (coverage) => !coverage.additionalDetail
          );
          // this.show = false;
          if (replacedCoverage && noDetailCoverage) {
            this.setReplacedInsuranceData(noDetailCoverage);
          }
        }
      },
      deep: true,
      immediate: true,
    },
  },
};
</script>
